module.exports = __webpack_public_path__ + "img/restaurant-music.7ae443a7.svg";